import { getStatusData, STATUS_DATA_TYPE } from "../../../Constant/StatusData";
import { formatDate, formatRP } from "../../../Utils/externalFunctions";
import { getStatusBadge } from "../../../Utils/otherFunctions";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import DateSortFunction from "../../DataTableComponents/DateSortFunction";

const getRincianTandaTerimaColumns = ({}) => {
  const columns = [
    {
      name: <DataTableTitle text={"Kode Transaksi"} />,
      selector: (row) => row.id_transaksi,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Diajukan Oleh"} />,
      selector: (row) => row.diajukan_oleh,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Tanggal Transaksi"} />,
      selector: (row) => formatDate(row.tanggal_transaksi),
      sortable: true,
      sortFunction: DateSortFunction("tanggal_transaksi"),
    },
    {
      name: <DataTableTitle text={"Keterangan"} />,
      selector: (row) => row.keterangan,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Dibayar Ke"} />,
      selector: (row) => row.dibayarkan_ke,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Diperlukan (Rp)"} />,
      selector: (row) => parseInt(row.nilai_transaksi),
      sortable: true,
      format: (row) => formatRP(row.nilai_transaksi),
    },
    {
      name: <DataTableTitle text={"Status Dokumen"} />,
      selector: (row) => {
        const statusData = getStatusData(
          row.status_dokumen,
          STATUS_DATA_TYPE.DokumenTransaksi
        );
        return getStatusBadge(statusData);
      },
      sortable: true,
    },
  ];

  return columns;
};

export default getRincianTandaTerimaColumns;
